/** Common Components */
import MolGrid, { Column } from "@moltech/molui/molgrid";
import FormSelectField from "../../../../../../../../components/finalForms/formFields/FormSelectField";
import { useContext, useEffect, useState } from "react";
import { useGetAllContractInvoicesMutation, useLazyGetAllInvoiceDepartmentsQuery } from "../../../../../../../../app/services/contractAPI";
import { ContractContext } from "../../../../../../../../utils/context/ContractContext";
import CardSection from "../../../../../../../../components/ui/card/CardSection";
import { ColumnGroup } from "primereact/columngroup";
import { Row } from "react-bootstrap";
import { dateFormatOfGroupHeaderTemplate } from "../../../../../../../../components/finalMolGrid/libs/formatDate";
import SwalAlert from "../../../../../../../../services/swalService/SwalService";

const Invoice = () => {
  const [department, setDepartment] = useState([]);
  const [selectedDepartment, setSelectedDepartment] = useState();
  const [gridData, setGridData] = useState([]);

  const { contractId } = useContext(ContractContext);
  const { confirm } = SwalAlert();

  const [getAllInvoiceDepartments, {
    isFetching: isInvoiceDepartmentsFetching,
    isSuccess: isInvoiceDepartmentsSuccess,
    data: invoiceDepartmentsData,
  },] = useLazyGetAllInvoiceDepartmentsQuery();

  const [contractInvoiceGet, {
    isSuccess: iscontractInvoiceGet,
    data: contractInvoiceData
  }] = useGetAllContractInvoicesMutation();

  useEffect(() => {
    if (contractId) {
      const request = {
        plContractKey: contractId,
        pbBillableOnly: false,
        pbIncludeBlank: false
      }
      getAllInvoiceDepartments(request);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [contractId]);

  useEffect(() => {
    if (contractId && selectedDepartment) {
      contractInvoiceGet({
        plContractKey: contractId,
        plDepartmentKey: selectedDepartment.value,
        plInvoiceKey: 0,
        pdtStartDate: null,
        pdtEndDate: null
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedDepartment]);

  useEffect(() => {
    if (!isInvoiceDepartmentsFetching && isInvoiceDepartmentsSuccess && invoiceDepartmentsData) {
      const allOption = { label: "All Departments", value: "0" };
      const mappedDepartmentList = invoiceDepartmentsData.map(u => ({
        value: u.lDepartmentKey,
        label: u.department,
      }));
      const updatedData = [allOption, ...mappedDepartmentList];
      setDepartment(updatedData);
      setSelectedDepartment(allOption);
    }
  }, [isInvoiceDepartmentsFetching, isInvoiceDepartmentsSuccess, invoiceDepartmentsData])

  useEffect(() => {
    if (iscontractInvoiceGet && contractInvoiceData) {
      setGridData(contractInvoiceData);
    }
  }, [iscontractInvoiceGet, contractInvoiceData]);

  const handleDropdownChange = (dataField, selectedOption) => {
    setSelectedDepartment(selectedOption);
  };

  const handleVoidInvoice = (rowData) => {
    if (rowData?.lInvoiceKey) {
      confirm(
        "Confirm Void?",
        "Are you sure you want to void the selected invoice",
        "Yes",
        "No"
      ).then((confirmed) => {
        if (confirmed) { }
      });
    }
  }

  const getCtxMenuItems = (row) => {
    if (!row) return [];
    return [
      {
        label: "View",
        command: () => { }
      },
      {
        label: 'Void',
        command: () => {
          handleVoidInvoice(row)
        }
      }
    ];
  }

  const total = Number(gridData?.[0]?.totalCount ?? 0);

  return (
    <div className="row gap-4">
      <CardSection
        customHeader={true}
      >
        <div className="col-5 ml-3">
          <FormSelectField
            fieldSetting={
              { options: department, placeholder: "Select Department" }
            }
            options={department}
            value={selectedDepartment}
            onChange={handleDropdownChange}
            labelName="Department :"
            isRequired={true}
          />
        </div>
        <div className="scrollable-grid col-12">
          <MolGrid
            value={gridData}
            grouping
            expandableRowGroups={true}
            paginator={false}
            scrollable
            scrollHeight="flex"
            filterDisplay="row"
            sortMode="single"
            showGridlines
            resizableColumns
            ctxMenuItems={getCtxMenuItems}
          >
            <Column
              field="dtTranDate"
              header="Invoice Date"
              colType="datetime"
              format="mm/dd/yyyy"
              rowGroupHeaderTemplate={dateFormatOfGroupHeaderTemplate("Invoice Date")}
              grouping
              sortable
              bodyStyle={{ textAlign: "center" }}
            />
            <Column field="sClientName1" header="Client" bodyStyle={{ textAlign: "left" }} grouping sortable />
            <Column
              field="sDepartmentName"
              header="Department"
              grouping
              sortable
              bodyStyle={{ textAlign: "Center" }}
            />
            <Column
              field="sTranNumber"
              header="Invoice Number"
              grouping
              sortable
              bodyStyle={{ textAlign: "Center" }}
            />
            <Column
              field="dblTranAmount"
              header="Invoice Amount"
              colType="money"
              footer={total.toLocaleString("en-US", {
                style: "currency",
                currency: "USD"
              })}
              footerStyle={{ textAlign: "right", fontWeight: "bold" }}
              grouping
              sortable
              bodyStyle={{ textAlign: "right" }}
            />
            <Column
              field="sCoveragePeriod"
              header="Coverage Period"
              grouping
              sortable
              bodyStyle={{ textAlign: "center" }}
            />
          </MolGrid>
        </div>
      </CardSection>
    </div >
  );
};
export default Invoice;
